<template>
  <div class="copy-row">
    <p class="gray-500 small-regular copy-row--content">{{ content }}</p>
      <v-popover
        :offset="8"
        placement='top'
        :open="popUpOpenPix"
      >
        <button
          class="copy-row--button"
          @click="copyContent"
        >
          Copiar
        </button>
        <template slot="popover">
          <div class="tooltip-arrow" />
          <div class="tooltip-text">
            Código copiado
          </div>
        </template>
      </v-popover>

  </div>
</template>

<script>
import Vue from 'vue';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip);

export default {
  name: 'copy-row',
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      popUpOpenPix: false,
    };
  },
  methods: {
    copyContent() {
      this.popUpOpenPix = true;
      navigator.clipboard.writeText(this.content);

      setTimeout(() => {
        if (this.popUpOpenPix) this.popUpOpenPix = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../scss/__new-styles.scss';

  .copy-row {
    cursor: pointer;
    width: 100%;
    height: 48px;
    border: 1px solid $gray-300;
    border-radius: 6px;
    background-color: $white;

    display: flex;

    p {
      flex: 1 1;
      padding: 12px 0px 12px 12px;
      overflow: hidden;

      background: $gray-500;
      background: -webkit-linear-gradient(to right, $gray-500 90%, #FFFFFF 100%);
      background: -moz-linear-gradient(to right, $gray-500 90%, #FFFFFF 100%);
      background: linear-gradient(to right, $gray-500 90%, #FFFFFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &:hover {
      .copy-row--button {
        background-color: $primary-200;
        border: 0;
      }
    }
  }

  .copy-row--content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 12px;
  }

  .copy-row--button {
    @extend .small-semi-bold;

    margin: 5px 5px 5px 0px;

    padding: 6px 16px;
    background-color: $primary-100;
    border-radius: 6px;
    color: $primary-600;
    border: 0;

    &:hover {
      background-color: $primary-200;
      border: 0;
    }
  }

  .tooltip {
  display: block !important;
  z-index: 2;

  .tooltip-text {
    background: var(--gray-900);
    color: white;
    border-radius: 6px;
    padding: 7px 12px;
    text-align: center;

    font-family: 'Usual';
    font-weight: 400;
    font-size: 18px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 1px;
    border-color: var(--gray-900);
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

</style>
